import { get, post } from "@/utils/http";

let baseURL = "/role";
/**
 * 获取角色列表
 */
const getRoleList = data => post(`${baseURL}/getAll`, { data });

const getAllRoles = data => get(`${baseURL}/findAllRoles`, data);
/**
 * 保存角色
 */
const saveRole = data => post(`${baseURL}/createRole`, { data });
/**
 * 删除角色
 */
const deleteRole = data => post(`${baseURL}/deleteById`, { data });
/**
 * 编辑角色
 */
const updateRole = data => post(`${baseURL}/updateRole`, { data });
/**
 * 编辑角色
 */
const findAllRoles = () => post(`${baseURL}/findAllRoles`,'');

/**
 *根据角色id获取菜单栏
 */
const getMenuListByRoleId = data =>
  post(`${baseURL}/getRoleMenuInfo`, { data });

// API
export default {
  findAllRoles,
  updateRole,
  deleteRole,
  getRoleList,
  getMenuListByRoleId,
  saveRole,
  getAllRoles
};
